import { PagePaths } from '@revelio/core';

const hiddenGlobalAIAssistantPathSegments = [
  'report',
  PagePaths.DATA_BUILDER,
  PagePaths.DATA_BUILDER_STATUS,
  `${PagePaths.DELIVERABLES}/${PagePaths.DATA_ENRICHMENT}`,
  PagePaths.REPORTS,
  PagePaths.REPORT_BUILDER,
  PagePaths.RESUME_ENRICHMENT,
] as const;

function pathnameMatchesTopLevelSegment(
  pathname: string,
  segment: string
): boolean {
  return pathname === `/${segment}` || pathname.startsWith(`/${segment}/`);
}

export function shouldHideGlobalAIAssistantForPathname(
  pathname: string
): boolean {
  return hiddenGlobalAIAssistantPathSegments.some((segment) =>
    pathnameMatchesTopLevelSegment(pathname, segment)
  );
}
